import { render, staticRenderFns } from "./datatypesDropdown.vue?vue&type=template&id=7445c8ca&scoped=true&"
import script from "./datatypesDropdown.vue?vue&type=script&lang=js&"
export * from "./datatypesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./datatypesDropdown.vue?vue&type=style&index=0&id=7445c8ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445c8ca",
  null
  
)

export default component.exports